import Vue from "vue"
import { AclInstaller, AclCreate, AclRule } from "vue-acl"
import router from "./../router"

Vue.use(AclInstaller)

let initialRole = "anonymous"

let userInfo = JSON.parse(localStorage.getItem("userInfo"))
debugger
if(userInfo && userInfo.userRole)
{
  initialRole = userInfo.userRole
}
export default new AclCreate({
  initial: initialRole,
  notfound: "/pages/login",
  router,
  acceptLocalRules: true,
  globalRules: {
    Coordinator: new AclRule("coordinator").generate(),
    trainee: new AclRule("trainee").generate(),
    instructor: new AclRule("instructor").or("evaluator").generate(),
    adminevaluatorinstructor: new AclRule("instructor").or("evaluator").or("admin").generate(),
    adminevaluatorinstructorCoordinator: new AclRule("instructor").or("evaluator").or("admin").or("trainingcoordinator").generate(),
    traineeInstructor: new AclRule("trainee").or("instructor").or("evaluator").generate(),
    Assessment: new AclRule("evaluator").or("admin").generate(),
    evaluator: new AclRule("evaluator").generate(),
    customer: new AclRule("customer").generate(),
    customertrainee: new AclRule("customer").or("trainee").generate(),
    admin: new AclRule("admin").generate(),
    trainingcoordinator: new AclRule("trainingcoordinator").or("coordinator").generate(),
    courseregistration: new AclRule("editor").or("admin").or("trainee").or("trainingcoordinator").generate(),
    courserequest: new AclRule("editor").or("admin").or("trainee").or("customer").or("trainingcoordinator").generate(),
    editor: new AclRule("editor").or("admin").generate(),
    anonymous: new AclRule("anonymous").or("admin").or("editor").or("trainee").or("instructor").or("customer").or("trainingcoordinator").or("evaluator").or("coordinator"),
    admintrainingcoordinator: new AclRule("trainingcoordinator").or("admin").or("editor").or("coordinator").generate(),
    all: new AclRule("trainee").or("admin").or("editor").or("instructor").or("customer").or("trainingcoordinator").or("evaluator").generate(),
  }
})
